import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { 
  faArrowRight,
  faUserTie,
  faCheckCircle,
  faBrain
} from '@fortawesome/free-solid-svg-icons';
import './Services.css';

const About = () => {
  const { t } = useTranslation();

  // Company values data now uses translation keys
  const companyValues = [
    {
      icon: faUserTie,
      letterKey: 'about.coreValues.professionalism.letter',
      titleKey: 'about.coreValues.professionalism.title',
      descriptionKey: 'about.coreValues.professionalism.description'
    },
    {
      icon: faCheckCircle,
      letterKey: 'about.coreValues.reliable.letter',
      titleKey: 'about.coreValues.reliable.title',
      descriptionKey: 'about.coreValues.reliable.description'
    },
    {
      icon: faBrain,
      letterKey: 'about.coreValues.openness.letter',
      titleKey: 'about.coreValues.openness.title',
      descriptionKey: 'about.coreValues.openness.description'
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section Modern */}
      <section className="page-hero modern-page-hero">
        <div className="page-hero-pattern"></div>
        <div className="page-hero-overlay"></div>
        <Container>
          <div className="page-hero-content">
            <div className="hero-badge animate-appear">
              <span className="hero-badge-text">{t('about.hero.badge')}</span>
            </div>
            <h1 className="animate-appear">{t('about.hero.title')}</h1>
            <p className="animate-appear">
              {t('about.hero.subtitle')}
            </p>
          </div>
        </Container>
      </section>

      {/* Company Overview Section Modern */}
      <section className="section modern-section">
        <Container>
          <h2 className="section-title modern-title">{t('about.history.title')}</h2>
          
          <Row className="align-items-center">
            <Col lg={6} md={12} className="mb-4 mb-lg-0">
              <div className="about-image-frame">
                <img src={process.env.PUBLIC_URL + '/images/nosotros/equipo.jpg'} alt={t('about.history.whoWeAre', '¿Quiénes Somos?')} style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'10px'}} />
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="about-content">
                <h3 className="mb-3">{t('about.history.whoWeAre')}</h3>
                <p className="lead-text">
                  {t('about.history.para1')}
                </p>
                <p className="lead-text mb-4">
                  {t('about.history.para2')}
                </p>
                <p>
                  {t('about.history.para3')}
                </p>
                <p>
                  {t('about.history.para4')}
                </p>
                <p>
                  {t('about.history.para5')}
                </p>
                <Link to="/contacto" className="modern-link">
                  {t('about.history.learnMoreLink')} <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission and Vision Section Modern */}
      <section className="section bg-light modern-section-light">
        <Container>
          <h2 className="section-title modern-title">{t('about.missionVision.title')}</h2>
          
          <Row>
            <Col lg={6} md={12} className="mb-4">
              <div className="mission-vision-box modern-card">
                <div className="mv-icon mission-icon">{t('about.missionVision.mission.letter')}</div>
                <h3>{t('about.missionVision.mission.title')}</h3>
                <p>
                  {t('about.missionVision.mission.text')}
                </p>
              </div>
            </Col>
            <Col lg={6} md={12} className="mb-4">
              <div className="mission-vision-box modern-card">
                <div className="mv-icon vision-icon">{t('about.missionVision.vision.letter')}</div>
                <h3>{t('about.missionVision.vision.title')}</h3>
                <p>
                  {t('about.missionVision.vision.text')}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Us Section - NEW */}
      <section className="section modern-section">
        <Container>
          <h2 className="section-title modern-title">{t('about.whyChooseUs.title')}</h2>
          <Row className="mt-5 justify-content-center">
            <Col lg={4} md={6} className="mb-4">
              <div className="value-box modern-card text-center h-100">
                <h3 className="value-title">{t('about.whyChooseUs.valueAdded.title')}</h3>
                <ul className="text-start">
                  <li dangerouslySetInnerHTML={{ __html: t('about.whyChooseUs.valueAdded.item1') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('about.whyChooseUs.valueAdded.item2') }} />
                </ul>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className="value-box modern-card text-center h-100">
                <h3 className="value-title">{t('about.whyChooseUs.customerService.title')}</h3>
                <p>{t('about.whyChooseUs.customerService.text')}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Values Section Modern - UPDATED */}
      <section className="section bg-light modern-section-light">
        <Container>
          <h2 className="section-title modern-title">{t('about.coreValues.title')}</h2>
          
          <Row className="mt-5">
            {companyValues.map((value, index) => (
              <Col lg={4} md={6} className="mb-4" key={index}>
                <div className="value-box modern-card text-center h-100">
                  <div className="value-icon modern-icon p-letter-icon">
                    {t(value.letterKey)}
                  </div>
                  <h3 className="value-title">{t(value.titleKey)}</h3>
                  <p>{t(value.descriptionKey)}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Team Section Modern */}
      {/*
      <section className="section bg-light modern-section-light">
        <Container>
          <h2 className="section-title modern-title">{t('about.team.title')}</h2>
          <p className="section-description text-center mb-5">
            {t('about.team.subtitle')}
          </p>
          
          <Row>
            {teamMembers.map((member) => (
              <Col lg={4} md={6} className="mb-4" key={member.id}>
                <div className="team-member modern-card">
                  <div className="team-member-image">
                    <div className="team-image-placeholder">
                      <div className="member-initials">{member.initials}</div>
                    </div>
                  </div>
                  <div className="team-member-info">
                    <h3 className="member-name">{t(member.nameKey)}</h3>
                    <p className="member-position">{t(member.positionKey)}</p>
                    <p className="member-bio">{t(member.descriptionKey)}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      */}

      {/* Achievements Section Modern */}
      {/*
      <section className="section modern-section">
        <Container>
          <h2 className="section-title modern-title">{t('about.achievements.title')}</h2>
          
          <div className="timeline">
            <Row>
              {achievements.map((achievement, index) => (
                <Col lg={6} md={12} className="mb-4" key={index}>
                  <div className="achievement-item modern-card">
                    <div className="achievement-year">{achievement.year}</div>
                    <h3 className="achievement-title">{t(achievement.titleKey)}</h3>
                    <p>
                      {t(achievement.descriptionKey)}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>
      */}

      {/* CTA Section Modern */}
      <section className="section cta-section modern-cta">
        <Container className="text-center">
          <h2 className="cta-title">{t('about.cta.title')}</h2>
          <p className="cta-description">
            {t('about.cta.description')}
          </p>
          <Link to="/contacto">
            <Button variant="primary" className="modern-button">
              {t('about.cta.button')}
              <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Button>
          </Link>
        </Container>
      </section>
    </div>
  );
};

export default About; 